<template>
    <div class="inspect" :class="{active: !isCollapse}" ref="inspectRef">
        <div class="inspect-border" ref="inspectBorderRef" @mousedown="mouseDown"></div>
        <div class="collapse-button d-flex align-center" style="cursor: pointer" @click="toggleCollapse">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="102" viewBox="0 0 12 102" fill="none"
                 v-if="isCollapse">
                <path d="M3 51L9 45L9 57L3 51Z" fill="#7B7B7B"/>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="102" viewBox="0 0 12 102" fill="none" v-else>
                <path d="M9 51L3 57V45L9 51Z" fill="#7B7B7B"/>
            </svg>
        </div>
        <div class="layout-header d-flex align-center justify-center">Debug details</div>
        <div class="inspect-wrapper">
            <div class="inspect-body">
                <div class="d-flex align-center justify-center pa-5" v-if="loading">
                    <v-progress-circular
                        color="#d3d3d3"
                        indeterminate
                    ></v-progress-circular>
                </div>
                <el-scrollbar class="scroll" wrap-class="scroll-wrapper" v-else>
                    <div class="pa-3 d-flex flex-column" style="gap: 20px" v-if="cardActive">
                        <div class="card-link" @click="onViewCard">
                            <img :src="'/img/scenario/card/normal/' + cardActive.config.card_type_id + '.svg'" alt="">
                            {{ cardTitle | capitalize }}: <span class="font-weight-medium">{{ cardName }}</span>
                            <v-spacer/>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                 fill="none">
                                <path
                                    d="M17.6572 14.8282L16.2429 13.414L17.6572 11.9998C19.2193 10.4377 19.2193 7.90506 17.6572 6.34296C16.0951 4.78086 13.5624 4.78086 12.0003 6.34296L10.5861 7.75717L9.17188 6.34296L10.5861 4.92875C12.9292 2.5856 16.7282 2.5856 19.0714 4.92875C21.4145 7.27189 21.4145 11.0709 19.0714 13.414L17.6572 14.8282ZM14.8287 17.6567L13.4145 19.0709C11.0714 21.414 7.27238 21.414 4.92923 19.0709C2.58609 16.7277 2.58609 12.9287 4.92923 10.5856L6.34345 9.17139L7.75766 10.5856L6.34345 11.9998C4.78135 13.5619 4.78135 16.0946 6.34345 17.6567C7.90555 19.2188 10.4382 19.2188 12.0003 17.6567L13.4145 16.2425L14.8287 17.6567ZM14.8287 7.75717L16.2429 9.17139L9.17188 16.2425L7.75766 14.8282L14.8287 7.75717Z"
                                    fill="#0052CC"/>
                            </svg>
                        </div>
                        <ContentSection :card="card"/>
                        <VariableSection v-if="!['kb_call', 'kb_mapping'].includes(cardActive.config.card_type_id)"/>
                        <ConstantSection
                            v-if="!['kb_call', 'kb_mapping'].includes(cardActive.config.card_type_id)"></ConstantSection>
                    </div>
                    <div class="d-flex pa-3 align-center justify-center" style="color: rgb(123, 123, 123)" v-else>
                        {{ $t('noDataAvailable') |capitalize }}
                    </div>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>

<script>
import { AppEventBus, AppEventBusType } from '@/eventbus/app.eventbus'
import { mapState } from 'vuex'
import ContentSection from '@/views/Debugger/Section/ContentSection.vue'
import VariableSection from '@/views/Debugger/Section/VariableSection.vue'
import { sync } from 'vuex-pathify'
import ConstantSection from '@/views/Debugger/Section/ConstantSection.vue'

export default {
    name: 'Inspect',
    components: {
        ConstantSection,
        VariableSection,
        ContentSection
    },
    mounted () {
        AppEventBus.on(AppEventBusType.VIEW_INSPECT, this.onViewInspect)
        this.initEvents()
    },
    data () {
        return {
            isCollapse: false,
            card: null,
            resizePressed: false
        }
    },
    computed: {
        ...mapState('debug', ['cardActive']),
        loading: sync('debug/loading'),
        cardTitle () {
            return this.cardActive.config.card_type_id.replaceAll('_', ' ')
        },
        cardName () {
            return this.cardActive.config.name.split('-')[0].trim()
        }
    },
    methods: {
        initEvents () {
            document.addEventListener('mouseup', this.mouseUp)
        },
        onViewInspect (payload) {
            console.log(payload)
        },
        toggleCollapse () {
            this.$refs.inspectRef.style = ''

            this.isCollapse = !this.isCollapse
            if (this.isCollapse) {
                this.$refs.inspectBorderRef.style.width = '0px'
                this.$refs.inspectBorderRef.style.padding = '0px'
            } else {
                this.$refs.inspectBorderRef.style.width = '5px'
                this.$refs.inspectBorderRef.style.padding = '4px'
            }
        },
        onViewCard () {
            if (this.cardActive.config.card_type_id.includes('kb')) {
                return
            }
            window.open(`/bots/${this.$route.params.botCode}/scenario?step=${this.cardActive.config.step_code}&card=${this.cardActive.config.code}`)
        },
        mouseDown (e) {
            document.body.style = '-webkit-user-select: none'
            this.$refs.inspectRef.style.transition = 'initial'
            document.addEventListener('mousemove', this.resize, false)
        },
        mouseUp (e) {
            document.body.style = ''
            this.$refs.inspectRef.style.transition = ''
            document.removeEventListener('mousemove', this.resize, false)
        },
        resize (e) {
            this.$refs.inspectRef.style.flexBasis = document.body.scrollWidth - e.clientX + 'px'
        }
    },
    destroyed () {
        AppEventBus.off(AppEventBusType.VIEW_INSPECT, this.onViewInspect)
        document.removeEventListener('mouseup', this.mouseUp)
    },
    watch: {
        cardActive () {
            this.loading = true
            this.card = this.cardActive ? {
                ...this.cardActive.config,
                config: JSON.parse(this.cardActive.config.config)
            } : {}
            setTimeout(() => {
                this.loading = false
            }, 300)
        }
    }
}
</script>
<style scoped lang="scss">
.inspect-border {
    width: 5px;
    padding: 4px;
    background-color: #EDEDED;
    height: 100%;
    position: absolute;
    left: -3px;
    z-index: 999;
    background-clip: content-box;
  transition: all 0.3s ease;
    &:hover {
        cursor: ew-resize;
    }
}

.inspect-wrapper {
    position: absolute;
    width: 100%;
    height: calc(100% - 30px);
    display: flex;
    bottom: 0;
}

.inspect-body {
    flex-grow: 1;
    position: relative;
    background-color: white;

    .scroll {
        position: absolute;
        height: 100%;
        width: 100%;
    }

    .card-link {
        display: flex;
        align-items: center;
        gap: 8px;
        font-weight: bold;
        padding: 10px;
        border-radius: 4px;
        border: 1px solid #0052CC;
        background: #FFF;
        cursor: pointer;
    }
}

.inspect {
    position: relative;
    transition: all 0.3s ease;
    flex: 0 0 0;
    border-radius: 4px;
    border-left: 1px solid #EDEDED;
    background: #EDEDED;
    flex-direction: column;

    &.active {
        flex-basis: 510px;
    }
}

.layout-header {
    position: absolute;
    width: 100%;
    height: 30px;
    overflow: hidden;
    background-color: #F4F4F4;
    padding: 4px 0;
    font-weight: bold;
    color: #7B7B7B;
}

.collapse-button {
    position: absolute;
    width: 12px;
    height: 102px;
    border-radius: 4px 0 0 4px;
    background: #EDEDED;
    z-index: 999;
    left: -12px;
    top: 50%;
}
</style>
